import { AssignLicensesDto } from "./licenseAssignmentTypes";

export type OrderItem = {
  isHardware?: boolean;
  licenseType: LicenseType;
  quantity: number;
};

export type Order = {
  _id: string;
  distId: string;
  orderNumber: number;
  orderYear: number;
  status: string;
  isPaid: boolean;
  orderItems: OrderItem[];
  assignLicensesInfo: AssignLicensesDto[];
  emailsToInform?: string[];
  createdAt?: string;
  updatedAt?: string;
};

export class CreateOrderDto {
  orderItems: CreateOrderItemDto[];
  emailsToInform?: string[];
  distId?: string;
}

export class CreateOrderItemDto {
  isHardware?: boolean;
  licenseType?: LicenseType;
  quantity: number;
}

export class ProductItem {
  hardwareModel?: string;
  serialNo?: string;
  alias?: string;
  licenseId?: string;
  scopeName?: string;
}

export type LicenseAndProduct = {
  licenseId: string;
  license_id: string;
  type: LicenseType;
  state?: LicenseState;
  invalidAfter?: Date;
  history: any[];

  orgId?: string;
  serialNo?: string;
};

export interface Organization {
  orgId?: string;
  name?: string;
  address?: string;
  country?: string;
  email?: string;
  creationDate?: Date;
  scopeName?: string;
  distId?: string;
  products?: ProductItem[];
  lastUpdateDate?: Date;
  isActive?: boolean;
  accountType?: AccountType[];
  accountInfo?: string;
  logoUrl?: string;
  logoFile?: File | null;

  // emails to inform about orders, license assignments, etc.
  emailsToInform?: string[];
}

export class OrgDto {
  name: string;
  email: string;
  address: string;
  creationDate?: Date;
  orgId: string;
  distId: string;
  products?: ProductItem[];
  accountType?: AccountType[];
  scopeName?: string;
  logoUrl?: string;
  accountInfo?: string;
}

export type AccountType =
  | "university"
  | "hospital"
  | "school"
  | "optometrist"
  | "optician"
  | "ophthalmologist"
  | "orthoptist"
  | "trial"
  | "study"
  | "nonprofit"
  | "other"
  | "subscription"
  | "rental"
  | "congress";

export type AccountTypeForVersionManagement = "demo" | "distributor";

export const AccountTypeForVersionManagementValues: AccountTypeForVersionManagement[] = [
  "demo",
  "distributor",
];

export const accountTypeValues: AccountType[] = [
  "university",
  "hospital",
  "school",
  "optometrist",
  "optician",
  "ophthalmologist",
  "orthoptist",
  "trial",
  "study",
  "nonprofit",
  "other",
  "subscription",
  "rental",
  "congress",
];

export type LicenseType =
  | "basic-vfa"
  | "upgraded-vfa"
  | "full-vfa"
  | "demo"
  | "unset"
  | "subscription"
  | "nonprofit";

export const LicenseTypeValues: LicenseType[] = [
  "basic-vfa",
  "upgraded-vfa",
  "full-vfa",
  "demo",
  "unset",
  "subscription",
  "nonprofit",
];

export type LicenseState =
  | "ordered"
  | "upgrade-ordered"
  | "active"
  | "unassigned"
  | "suspended"
  | "expired"
  | "rejected"
  | "cancelled";

export const LicenceStateValues: LicenseState[] = [
  "ordered",
  "upgrade-ordered",
  "active",
  "unassigned",
  "suspended",
  "expired",
  "rejected",
  "cancelled",
];

export type OrderStatus = "created" | "rejected" | "cancelled" | "approved";

export const OrderStatusValues: OrderStatus[] = ["created", "rejected", "cancelled", "approved"];
